import { Navigate, Outlet } from 'react-router-dom';
import { isAdminAccount } from 'src/lib/auth/roles';
import { useAuth } from 'src/lib/auth/use-auth';
import { DashboardHeader } from './DashboardHeader.component';
import { DashboardSideBar } from './DashboardSideBar.component';

export function DashboardContainer() {
  const { isAuthenticated, user, locationState } = useAuth();

  if (isAuthenticated && !isAdminAccount(user)) {
    return <Navigate to="/map" replace />;
  }

  return isAuthenticated ? (
    <>
      <DashboardHeader />
      <DashboardSideBar />
      <Outlet />
    </>
  ) : (
    <>
      <DashboardHeader />
      <Outlet context={locationState} />
    </>
  );
}
